import React from 'react';
import { TrophyIcon, CalendarIcon, ExternalLinkIcon, FacebookIcon, TwitterIcon, InstagramIcon } from 'lucide-react';
const TeamHero = () => {
  const teamData = {
    name: 'New York Knicks',
    league: 'NBA',
    conference: 'Eastern Conference',
    division: 'Atlantic Division',
    founded: '1946',
    arena: 'Madison Square Garden',
    officialSite: 'https://www.nba.com/knicks',
    social: {
      twitter: '@nyknicks',
      instagram: '@nyknicks',
      facebook: 'NewYorkKnicks'
    }
  };
  const teamStats = {
    ranking: 3,
    points: 42,
    totalPoints: 2184,
    avgPoints: 84.0,
    totalRebounds: 1350,
    avgRebounds: 51.9,
    totalAssists: 624,
    avgAssists: 24.0,
    overallRecord: {
      wins: 42,
      losses: 26
    },
    homeRecord: {
      wins: 24,
      losses: 10
    },
    awayRecord: {
      wins: 18,
      losses: 16
    },
    overallRating: 89.5,
    offensiveRating: 112.4,
    defensiveRating: 108.6
  };
  const nextMatch = {
    opponent: 'Boston Celtics',
    opponentLogo: 'https://a.espncdn.com/i/teamlogos/nba/500/bos.png',
    date: 'March 22, 2024',
    time: '19:30',
    venue: 'TD Garden',
    isHome: false
  };
  const lastMatch = {
    opponent: 'Los Angeles Lakers',
    opponentLogo: 'https://a.espncdn.com/i/teamlogos/nba/500/lal.png',
    date: 'March 15, 2024',
    venue: 'Madison Square Garden',
    homeScore: 112,
    awayScore: 108,
    result: 'W',
    isHome: true
  };
  return <div className="space-y-6 mb-6" data-id="element-325" data-mp="1w2jkjtghl14l">
      {/* Main row with all three components */}
      <div className="grid grid-cols-12 gap-6" data-id="element-326" data-mp="1r488dc2pyej7">
        {/* Team Statistics - First box */}
        <div className="col-span-3 bg-white p-4 rounded-lg shadow-md border border-gray-200" data-id="element-327" data-mp="1m6yla32syeyj">
          <div className="flex items-center gap-3 mb-4" data-id="element-328" data-mp="1h8ws2pbnwz9c">
            <img src="https://a.espncdn.com/i/teamlogos/nba/500/ny.png" alt="New York Knicks" className="w-12 h-12 object-contain" data-id="element-329" data-mp="3gkzkwq66f5zo" />
            <div data-id="element-330" data-mp="3bmo9ib08gnfc">
              <h3 className="font-bold text-base mb-0.5" data-id="element-331" data-mp="3bm64aovleyva">New York Knicks</h3>
              <div className="text-xs text-gray-600 font-medium" data-id="element-332" data-mp="19vfg4d6i2lza">
                NBA EASTERN
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-3 mb-3" data-id="element-333" data-mp="zy1brbxupnnc">
            <div className="grid grid-cols-3 gap-2 mb-2" data-id="element-334" data-mp="zzm8n87n1iod">
              <div className="text-center" data-id="element-335" data-mp="14wl0fk3txdje">
                <div className="text-xs text-gray-500 font-semibold mb-0.5" data-id="element-336" data-mp="14xdxtugweqov">
                  OVERALL
                </div>
                <div className="text-sm font-bold text-gray-900" data-id="element-337" data-mp="1skvvu7qral0a">
                  {teamStats.overallRecord.wins}W -{' '}
                  {teamStats.overallRecord.losses}L
                </div>
              </div>
              <div className="text-center" data-id="element-338" data-mp="1nnc5wakp4jsi">
                <div className="text-xs text-gray-500 font-semibold mb-0.5" data-id="element-339" data-mp="1nm10y7fil5zt">
                  HOME
                </div>
                <div className="text-sm font-bold text-gray-900" data-id="element-340" data-mp="88y6pty5499n">
                  {teamStats.homeRecord.wins}W - {teamStats.homeRecord.losses}L
                </div>
              </div>
              <div className="text-center" data-id="element-341" data-mp="4n347lpue69f">
                <div className="text-xs text-gray-500 font-semibold mb-0.5" data-id="element-342" data-mp="3vvh852h3sumw">
                  AWAY
                </div>
                <div className="text-sm font-bold text-gray-900" data-id="element-343" data-mp="em2f7ay2ydzl">
                  {teamStats.awayRecord.wins}W - {teamStats.awayRecord.losses}L
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-2" data-id="element-344" data-mp="3i4c6juu6ds9x">
            <div className="border-t border-gray-200 pt-2" data-id="element-345" data-mp="3d4r77jb3fhwo">
              <div className="flex justify-between items-center" data-id="element-346" data-mp="3d6anh9wr1syg">
                <span className="text-xs font-medium text-gray-600" data-id="element-347" data-mp="3rtvq72pppq5u">
                  OVERALL RATING
                </span>
                <span className="text-base font-bold text-gray-900" data-id="element-348" data-mp="3n25diq3ayqb9">
                  {teamStats.overallRating}
                </span>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-2" data-id="element-349" data-mp="2uerjp0uwiavd">
              <div className="flex justify-between items-center" data-id="element-350" data-mp="2ucf6t2402qp6">
                <span className="text-xs font-medium text-gray-600" data-id="element-351" data-mp="1xo624n4u01tm">
                  OFFENSIVE RATING
                </span>
                <span className="text-base font-bold text-yellow-600" data-id="element-352" data-mp="21mdihgvdv14a">
                  {teamStats.offensiveRating}
                </span>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-2" data-id="element-353" data-mp="2bfu8sawb9y37">
              <div className="flex justify-between items-center" data-id="element-354" data-mp="2gdvtf09dy5gs">
                <span className="text-xs font-medium text-gray-600" data-id="element-355" data-mp="2gfozoeg36no9">
                  DEFENSIVE RATING
                </span>
                <span className="text-base font-bold text-red-600" data-id="element-356" data-mp="2pdiwdqhrjjby">
                  {teamStats.defensiveRating}
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Strengths & Weaknesses - Second box (wider) */}
        <div className="col-span-6 bg-white p-6 rounded-lg shadow-md" data-id="element-357" data-mp="v24698kubhvo">
          <h3 className="font-semibold text-lg mb-4 border-b pb-2" data-id="element-358" data-mp="zzvwly5u6vxr">
            Strengths & Weaknesses
          </h3>
          <div className="grid grid-cols-2 gap-6" data-id="element-359" data-mp="sgwdzuq798fg">
            <div data-id="element-360" data-mp="nod3j6mt6tev">
              <h5 className="font-medium text-sm text-green-600 mb-3" data-id="element-361" data-mp="nntqo4c0mv7p">
                Strengths
              </h5>
              <ul className="list-disc pl-5 space-y-2 text-sm" data-id="element-362" data-mp="iqbfe7aj03wj">
                <li data-id="element-363" data-mp="drgpkle55f2x">
                  Elite offensive efficiency (78th percentile) with strong ball
                  movement
                </li>
                <li data-id="element-364" data-mp="1bcd0wpemli2f">Above-average scoring ability (82nd percentile in PPG)</li>
                <li data-id="element-365" data-mp="16fw2n2dppnbm">
                  Excellent 3-point shooting (68th percentile) creates floor
                  spacing
                </li>
              </ul>
            </div>
            <div data-id="element-366" data-mp="xdmtafu6jzzt">
              <h5 className="font-medium text-sm text-red-600 mb-3" data-id="element-367" data-mp="xe4wxxj69ghr">
                Weaknesses
              </h5>
              <ul className="list-disc pl-5 space-y-2 text-sm" data-id="element-368" data-mp="3m7tm2bekb4vd">
                <li data-id="element-369" data-mp="3i3u9u50bes7t">
                  Turnover-prone offense (45th percentile in TOV%) limits
                  possessions
                </li>
                <li data-id="element-370" data-mp="3jk84z6fu4fg1">
                  Below-average in steals (65th percentile) indicates passive
                  perimeter defense
                </li>
                <li data-id="element-371" data-mp="39mv55ci1lamz">Mediocre rim protection (58th percentile in BLK/G)</li>
              </ul>
            </div>
          </div>
        </div>
        {/* Next Match and Last Match - Third box */}
        <div className="col-span-3 bg-white p-4 rounded-lg shadow-md flex flex-col space-y-4" data-id="element-372" data-mp="30ujo2h8tizjo">
          {/* Next Match */}
          <div data-id="element-373" data-mp="35nupg2uv2o47">
            <div className="flex items-center mb-3" data-id="element-374" data-mp="35oe67g8rz6gn">
              <CalendarIcon className="w-4 h-4 mr-2 text-blue-600" data-id="element-375" data-mp="2qygc6jo5zmjj" />
              <h3 className="font-semibold text-sm" data-id="element-376" data-mp="2vw8fe9u9ev31">NEXT MATCH</h3>
            </div>
            <div className="text-center" data-id="element-377" data-mp="2vu5cip80d7gw">
              <div className="flex justify-center items-center mb-3" data-id="element-378" data-mp="2hxrwzln1bg52">
                <div className="flex flex-col items-center" data-id="element-379" data-mp="2ly2f1wo3px0a">
                  <img src="https://a.espncdn.com/i/teamlogos/nba/500/ny.png" alt="Knicks" className="w-10 h-10 object-contain mb-1" data-id="element-380" data-mp="2lxiu0735msi1" />
                  <span className="text-xs font-medium text-gray-600" data-id="element-381" data-mp="1yb6u9mrwtfk6">NYK</span>
                </div>
                <div className="mx-3 text-sm font-medium text-gray-600" data-id="element-382" data-mp="2cagc0qvrkhq9">@</div>
                <div className="flex flex-col items-center" data-id="element-383" data-mp="2c8bxzg45i2c9">
                  <img src={nextMatch.opponentLogo} alt={nextMatch.opponent} className="w-10 h-10 object-contain mb-1" data-id="element-384" data-mp="27atzykro97j1" />
                  <span className="text-xs font-medium text-gray-600" data-id="element-385" data-mp="2m71dj28krapc">BOS</span>
                </div>
              </div>
              <div className="text-xs font-normal text-gray-500" data-id="element-386" data-mp="2h7yj0bq80mvm">
                {nextMatch.date} {nextMatch.time}
              </div>
            </div>
          </div>
          {/* Divider */}
          <div className="border-t border-gray-200" data-id="element-387" data-mp="2r1yoiepezu4v"></div>
          {/* Last Match */}
          <div data-id="element-388" data-mp="34x9fvi4g9x4h">
            <div className="flex items-center mb-3" data-id="element-389" data-mp="300amj1sm1u7c">
              <TrophyIcon className="w-4 h-4 mr-2 text-green-600" data-id="element-390" data-mp="301lnyuyl2pva" />
              <h3 className="font-semibold text-sm" data-id="element-391" data-mp="b7vhd08n0z2a">LAST MATCH</h3>
            </div>
            <div className="text-center" data-id="element-392" data-mp="f8xk3r1rjt90">
              <div className="flex justify-center items-center mb-2" data-id="element-393" data-mp="f7mdljgxo7e7">
                <div className="flex flex-col items-center" data-id="element-394" data-mp="k7ikprkxgexz">
                  <img src="https://a.espncdn.com/i/teamlogos/nba/500/ny.png" alt="Knicks" className="w-10 h-10 object-contain mb-1" data-id="element-395" data-mp="k5xqy46ft016" />
                  <span className="text-xs font-medium" data-id="element-396" data-mp="3np91xgxm694u">Knicks</span>
                </div>
                <div className="mx-2 flex flex-col items-center" data-id="element-397" data-mp="3snkc5srtmlnl">
                  <span className={`text-lg font-semibold ${lastMatch.result === 'W' ? 'text-green-600' : 'text-red-600'}`} data-id="element-398" data-mp="3slr54cdapzf2">
                    {lastMatch.homeScore} - {lastMatch.awayScore}
                  </span>
                  <span className="text-xs font-normal text-gray-600" data-id="element-399" data-mp="34y98a2f6cb58">vs</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-400" data-mp="39xcehq6w4nes">
                  <img src={lastMatch.opponentLogo} alt={lastMatch.opponent} className="w-10 h-10 object-contain mb-1" data-id="element-401" data-mp="39vrli5085cj1" />
                  <span className="text-xs font-medium" data-id="element-402" data-mp="32bqnjkwjggd7">Lakers</span>
                </div>
              </div>
              <div className="text-xs font-normal text-gray-600" data-id="element-403" data-mp="2xcvza3fsxzlp">
                {lastMatch.date}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TeamHero;